<template>
  <div>
    <Header />
    <div class="signup-wrapper">
      <div class="signup-container">
        <div class="signup-page text-center">
          <h2 class="font-white mb-4 pt-5 bold-text">SIGN UP</h2>
          <form class="mt-5">
            <div class="row mb-3">
              <div class="col-12 mt-3 text-left">
                <!-- <label for="email" class="mb-1 input-label">Email</label> -->
                <a-input :size="'large'" placeholder="Email" @keyup.enter="signinup()" v-model.lazy="$v.signup.email.$model" />
                <div class="error-container" v-if="$v.signup.email.$error">
                  <div class="error-item" v-if="!$v.signup.email.required">
                    Email is required
                  </div>
                  <div class="error-item" v-if="!$v.signup.email.email">
                    Invalid email address
                  </div>
                </div>
              </div>
              <div class="col-12 mt-3 text-left">
                <!-- <label for="password" class="mb-1 input-label">Password</label> -->
                <a-input-password :size="'large'" placeholder="Password" @keyup.enter="signinup()" v-model="$v.signup.password.$model" />
                <div class="error-container" v-if="$v.signup.password.$error">
                  <div class="error-item" v-if="!$v.signup.password.required">
                    Password is required
                  </div>
                </div>
              </div>
              <div class="col-12 mt-3 text-left">
                <!-- <label for="password" class="mb-1 input-label">Password</label> -->
                <a-input-password :size="'large'" placeholder="Confirm Password" @keyup.enter="signinup()" v-model="$v.signup.cPassword.$model" />
                <div class="error-container" v-if="$v.signup.cPassword.$error">
                  <div class="error-item" v-if="!$v.signup.cPassword.required">
                    Password confirmation is required
                  </div>
                  <div class="error-item" v-if="!$v.signup.cPassword.sameAsPassword">
                    Password did not match
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="terms text-justify">
            By logging into DoveMed you agree to your
            <a class="active">Terms of Use</a>
            and
            <a class="active">Privacy Policy.</a> We have changed the login system from username/password. If you do not remember your email, please send a mail to
            <a href="mailto:contact@dovemed.com" class="active">contact@dovemed.com.</a>
          </div>
          <div class="buttons-group mt-5 text-center">
            <a-button
              :loading="loading"
              @click="signinup()"
              :style="{
                border: '1px solid ' + getPrimaryFallbackColor(),
                color: getPrimaryFallbackColor(),
              }"
              class="dovemed-button font-white login-button"
              >SIGNUP</a-button
            >
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <EmailVerifyModal ref="emailVerifyModal" />
  </div>
</template>

<script>
import Header from "../App/HeaderGeneric"
import Footer from "../App/FooterGeneric"
import { mapGetters } from "vuex"
import EmailVerifyModal from "../Modals/EmailVerification"
import { required, email, sameAs } from "vuelidate/lib/validators"

export default {
  name: "SignupPage",
  components: {
    Header,
    Footer,
    EmailVerifyModal,
  },
  data() {
    return {
      signup: {
        email: null,
        password: null,
        cPassword: null,
      },
      error: false,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      currentCircle: "Circle/currentCircle",
    }),
  },
  validations: {
    signup: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
      cPassword: {
        required,
        sameAsPassword: sameAs("password"),
      },
    },
  },
  created() {
    console.warn("Signup.vue is created")
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    signinup() {
      this.loading = true
      const data = this.signup
      this.$v.$touch()
      this.errors = this.$v.signup.$anyError
      if (!this.errors) {
        this.$store
          .dispatch("Auth/register", { data })
          .then(res => {
            this.loading = false
            localStorage.setItem("userEmail", this.signup.email)
            this.$refs.emailVerifyModal.show()
          })
          .catch(err => {
            this.$notification.error({
              message: "Error",
              description: "Invalid email or password",
            })
            this.loading = false
          })
      } else {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.signup-wrapper {
  min-height: 700px;
  padding: 0;
  margin: 0;
  .signup-container {
    background: #0f74bd !important;
    margin: 0;
    padding: 40px;
    min-height: 700px;
    min-width: 100%;
    .signup-page {
      max-width: 550px;
      margin: auto;
    }
  }
  .login-button {
    width: 250px;
  }
  .terms {
    font-size: 14px;
    color: white !important;
    a.active {
      color: pink !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/Signup.vue